// extracted by mini-css-extract-plugin
module.exports = {"transactionContent":"style_transactionContent__2-gHk","uploadTransactions":"style_uploadTransactions__3BgHj","missing":"style_missing__3vh8z","footer":"style_footer__2D3th"};